import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=8d5f6a7e&"
import script from "./CreateProject.vue?vue&type=script&lang=ts&"
export * from "./CreateProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports